module.exports = __webpack_public_path__ + "static/media/P7.816a6a11.png";